const autofillData = (stateArray, setArray) => {

    stateArray.forEach((item, i) => {
        let freshItem = {...item,
            currentValue: '1',
        units: 'cm',
        currentJust: 'x',
        criteriaLow: '1',
        criteriaHigh: '1',
        criteriaType: 'Reference',
        criteriaJust: 'x',
        trajectLow: '1',
        trajectHigh: '1',
        trajectJust: 'x',
        forecastYears: '1',
        forecastJust: 'x',
        }

        setArray[i](freshItem)
    })

    return

}

export default autofillData